/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm

// Core
import type ClientApplication from '@client/app';
import type ClientPage from '@client/services/router/response/page';

/*----------------------------------
- TYPES
----------------------------------*/

declare global {
    interface Window {
        // Defined by loading gtag.js
        dataLayer: {
            push:  (params: {
                event: TEventAction
            }) => void,
        }
    }
}

export type TEventAction = 
    'page_view'

/*----------------------------------
- SERVICE
----------------------------------*/
export default class ClientMetrics {

    public constructor( public app: ClientApplication ) {

    }

    public start() {
        
    }

    public pageView( page: ClientPage ) {

        // GA
        this.event('page_view');

        // Save page history
        this.savePageHistory();
    }

    private savePageHistory() {

        // Only if not signed up
        const user = this.app.Router.context.user;
        if (user) return;
        
        // Save page history via localstorage
        const currentHistoryString = localStorage.getItem('pageHistory') || '[]';
        const currentHistory = JSON.parse(currentHistoryString);

        const currentPage = window.location.pathname + window.location.search;
        const previousPage = currentHistory[currentHistory.length - 1];

        if (previousPage !== currentPage && currentHistory.length < 100) {

            // Add current page
            currentHistory.push([currentPage, new Date().toISOString()]);

            // Save history
            localStorage.setItem('pageHistory', JSON.stringify(currentHistory));
        }
    }

    // Tracking
    public event( action: TEventAction, params?: {} ) {
        if (!window.dataLayer) return console.warn("[tracker] Google Analytics wasn't imported in header > scripts.");
        window.dataLayer.push({ event: action });
    }
}